export const styleM2 = {
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'preco_m2']],
    2000,
    '#FF3333',
    4000,
    '#FF3333',
    6000,
    '#FF9933',
    8000,
    '#FFFF33',
    10000,
    '#99FF33',
    12000,
    '#33FF33',
    14000,
    '#33FF99',
    16000,
    '#33FFFF',
    18000,
    '#3399FF',
  ],
  'circle-radius': 15,
  'circle-opacity': 1,
}

export const styleM2Aluguel = {
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'aluguel_total_m2']],
    30,
    '#FF3333',
    40,
    '#FF9933',
    50,
    '#FFFF33',
    60,
    '#99FF33',
    70,
    '#33FF33',
    80,
    '#33FF99',
    90,
    '#33FFFF',
    100,
    '#3399FF',
  ],
  'circle-radius': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'quartos']],
    4,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
  ],
  'circle-opacity': 0.6,
}

export const styleTicketAluguel = {
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'preco_m2']],
    1000,
    '#FF0000',
    2000,
    '#FF5500',
    4000,
    '#FFAA00',
    6000,
    '#FFEF00',
    8000,
    '#CCFF00',
    10000,
    '#80FF00',
    12000,
    '#33FF66',
    14000,
    '#00FFCC',
    16000,
    '#0099FF',
    18000,
    '#0033FF',
  ],
  'circle-radius': 15,
  'circle-opacity': 1,
}

export const styleTicket = {
  'fill-color': [
    'interpolate',
    ['linear'],
    ['to-number', ['get', 'valor']],
    255000,
    '#FF3333',
    350000,
    '#FF3333',
    500000,
    '#FF9933',
    750000,
    '#FFFF33',
    1000000,
    '#33FF33',
    1500000,
    '#33FFFF',
    10000000,
    '#3399FF',
  ],
  'circle-radius': 15,
  'circle-opacity': 1,
}
